import React from 'react';
import { useParams } from 'react-router-dom';
import { NotFound } from './NotFound';
import { productPages } from '../data/products';
import { financeDisclosure } from '../data/products/businessFinance';
import { ProductHero } from '../components/product/ProductHero';
import { ProductStats } from '../components/product/ProductStats';
import { BenefitCards } from '../components/product/BenefitCards';
import { FeatureRows } from '../components/product/FeatureRows';
import { HowItWorks } from '../components/product/HowItWorks';
import { RelatedProducts } from '../components/product/RelatedProducts';
import { IndustryCards } from '../components/product/IndustryCards';
import { ProductTestimonial } from '../components/product/ProductTestimonial';
import { PricingTeaser } from '../components/product/PricingTeaser';
import { ProductFaq } from '../components/product/ProductFaq';
import { DisclosurePanel } from '../components/product/DisclosurePanel';
import { ProductCta } from '../components/product/ProductCta';
type ProductPageProps = {
  showDisclosurePreview?: boolean;
};
export function ProductPage({
  showDisclosurePreview = false
}: ProductPageProps) {
  const {
    slug = ''
  } = useParams();
  const product = productPages[slug];
  if (!product) return <NotFound data-id="element-2128" data-mp="1lpmy8o8djve1" />;
  const disclosure = product.disclosure ?? (showDisclosurePreview ? financeDisclosure : undefined);
  return <main data-id="element-2129" data-mp="t06c28bclaq9">
      <ProductHero product={product} data-id="element-2130" data-mp="t0g37z84pnxj" />
      <ProductStats stats={product.stats} data-id="element-2131" data-mp="t1hbxx1o9yc3" />
      <BenefitCards heading={product.benefits.heading} items={product.benefits.items} data-id="element-2132" data-mp="xz94mta55ohc" />
      <FeatureRows heading={product.features.heading} subheading={product.features.subheading} items={product.features.items} data-id="element-2133" data-mp="xwwpsozoju8i" />
      <HowItWorks heading={product.steps.heading} items={product.steps.items} data-id="element-2134" data-mp="17q410qh3q4gi" />
      <RelatedProducts heading={product.related.heading} subheading={product.related.subheading} items={product.related.items} data-id="element-2135" data-mp="aaghnmbhyqyv" />
      <IndustryCards heading={product.industries.heading} subheading={product.industries.subheading} items={product.industries.items} data-id="element-2136" data-mp="f6ezss68fcqu" />
      <ProductTestimonial testimonial={product.testimonial} data-id="element-2137" data-mp="35p4b6u42ps4" />
      <PricingTeaser {...product.pricingTeaser} data-id="element-2138" data-mp="gyeqpcdjxwpr" />
      <ProductFaq heading={product.faq.heading} items={product.faq.items} data-id="element-2139" data-mp="gx3nperxkszp" />
      {disclosure && <DisclosurePanel disclosure={disclosure} data-id="element-2140" data-mp="bzbxqqaujgy5" />}
      <ProductCta headline={product.cta.headline} subheadline={product.cta.subheadline} data-id="element-2141" data-mp="3kec19mfml6om" />
    </main>;
}